import api from './api';

const CLE = 'nexacom_logo';

export const logoService = {
  /** Lecture synchrone depuis le cache local (pour le rendu immédiat). */
  getLogo(): string | null {
    return localStorage.getItem(CLE);
  },

  aLogo(): boolean {
    return !!localStorage.getItem(CLE);
  },

  /** Récupère le logo partagé depuis le serveur et met à jour le cache local. */
  async synchroniser(): Promise<string | null> {
    try {
      const res = await api.get('/configurations/logo');
      const logo: string | null = res.data?.logo || null;
      if (logo) {
        localStorage.setItem(CLE, logo);
      } else {
        localStorage.removeItem(CLE);
      }
      return logo;
    } catch (e) {
      // Hors ligne ou erreur : on conserve le cache existant.
      return localStorage.getItem(CLE);
    }
  },

  /** Enregistre le logo côté serveur (partagé) puis met à jour le cache local. */
  async setLogo(base64: string): Promise<void> {
    await api.put('/configurations/logo', { logo: base64 });
    localStorage.setItem(CLE, base64);
  },

  /** Supprime le logo côté serveur puis vide le cache local. */
  async supprimer(): Promise<void> {
    await api.put('/configurations/logo', { logo: '' });
    localStorage.removeItem(CLE);
  },
};
